import React, { Component, Fragment } from "react";
import { ThemeProvider } from "styled-components";
import { Grid, Col, Row } from "react-styled-flexboxgrid";

import styled from "styled-components";
import DocumentMeta from "react-document-meta";

import * as actions from "../../actions";
import { connect } from "react-redux";

import ImageScroller from "../ImageScroller";
import InfoPanel from "../InfoPanel";
import FeedbackItem from "../FeedbackItem";
import ContactBanner from "../ContactBanner";

import PanelWrapper from "../layout/PanelWrapper";
import Loader from "../Loader";

const theme = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // rem
    gutterWidth: 1, // rem
    outerMargin: 0, // rem
    mediaQuery: "only screen",
    container: {
      sm: 30, // rem
      md: 50, // rem
      lg: 61.25 // rem
    },
    breakpoints: {
      xs: 0, // em
      sm: 30, // em
      md: 50, // em
      lg: 61.25 // em
    }
  }
};

class HomeContent extends Component {
  componentDidMount(prevProps) {
    window.scrollTo(0, 0);
    this.props.loadHomeContent();
    this.props.loadHomeServices();
    this.props.loadHomeReview();
  }

  render() {
    const meta = {
      title: "Home - Arthur Perfect Job",
      description:
        "Arthur Perfect Job. Plumbing, Demolition, Carpentry / Joinery, Electrics, Plastering / Rendering, Flooring, Drylining, Painting and Decorating, Suspended Ceilings, Handyman Service, Partition walls, Tiling.",
      meta: {
        charset: "utf-8",
        name: {
          keywords:
            "plumbing,demolition,carpentry,joinery,electrics,plastering,rendering,flooring,drylining,painting,decorating,suspended,ceilings,handyman,service,partition,walls,tiling.",
          "og:title": "Home - Arthur Perfect Job",
          "og:img": "https://apjhomerenovation.co.uk/img/opengraph.jpg",
          "og:type": "website"
        }
      }
    };
    return (
      <Fragment>
        <DocumentMeta {...meta} />
        <PanelWrapper padding="0px">
          <ImageScroller
            loading={this.props.content.loadingScrollerImages}
            images={this.props.content.scrollerImages}
          />
        </PanelWrapper>

        <ThemeProvider theme={theme}>
          <Grid style={{ width: "100%", padding: "-4rem", overflow: "hidden" }}>
            {/* <Row style={{ padding: 0, margin: 0 }}> */}
            <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <PanelWrapper>
                  <InfoPanel
                    size="10px"
                    mgn="0 5px 0 0"
                    key={0}
                    loading={this.props.content.loadingServices}
                    tags={
                      !this.props.content.loadingServices
                        ? this.props.content.services[0]["acf"]["tags"]
                        : null
                    }
                    name={
                      !this.props.content.loadingServices
                        ? this.props.content.services[0]["acf"]["title"]
                        : null
                    }
                    description={
                      !this.props.content.loadingServices
                        ? this.props.content.services[0]["acf"]["description"]
                        : null
                    }
                  />
                </PanelWrapper>
              </Col>
              <Col xs={12} sm={12} md={12} lg={4}>
                <PanelWrapper>
                  <InfoPanel
                    size="10px"
                    mgn="0 5px 0 0"
                    key={1}
                    loading={this.props.content.loadingServices}
                    tags={
                      !this.props.content.loadingServices
                        ? this.props.content.services[1]["acf"]["tags"]
                        : null
                    }
                    name={
                      !this.props.content.loadingServices
                        ? this.props.content.services[1]["acf"]["title"]
                        : null
                    }
                    description={
                      !this.props.content.loadingServices
                        ? this.props.content.services[1]["acf"]["description"]
                        : null
                    }
                  />
                </PanelWrapper>
              </Col>
              <Col xs={12} sm={12} md={12} lg={4}>
                <PanelWrapperTable>
                  <InfoPanel
                    size="10px"
                    mgn="0 5px 0 0"
                    key={2}
                    loading={this.props.content.loadingServices}
                    tags={
                      !this.props.content.loadingServices
                        ? this.props.content.services[2]["acf"]["tags"]
                        : null
                    }
                    name={
                      !this.props.content.loadingServices
                        ? this.props.content.services[2]["acf"]["title"]
                        : null
                    }
                    description={
                      !this.props.content.loadingServices
                        ? this.props.content.services[2]["acf"]["description"]
                        : null
                    }
                  />
                </PanelWrapperTable>
              </Col>
            </Row>
          </Grid>
        </ThemeProvider>

        <PanelWrapper padding="0px" color="rgba(0,0,0,0)">
          <ContactBanner text="Click here to contact us" />
        </PanelWrapper>

        {this.props.content.loadingFeedback ? (
          <PanelWrapper>
            <Loader />
          </PanelWrapper>
        ) : (
          <FeedbackItem
            home={true}
            reviewer={
              !this.props.content.loadingFeedback
                ? this.props.content.feedback.acf.name
                : null
            }
            date={
              !this.props.content.loadingFeedback
                ? this.props.content.feedback.acf.date
                : null
            }
            reviewText={
              !this.props.content.loadingFeedback
                ? this.props.content.feedback.acf.review_text
                : null
            }
            link={
              !this.props.content.loadingFeedback
                ? this.props.content.feedback.acf.link
                : null
            }
            loading={
              !this.props.content.loadingFeedback
                ? this.props.content.loadingFeedback
                : null
            }
          />
        )}
      </Fragment>
    );
  }
}

const PanelWrapperTable = styled(PanelWrapper)`
  display: table-cell;
  width: 100%;
`;

function mapStateToProps(state) {
  return { content: state.home };
}

export default connect(
  mapStateToProps,
  actions
)(HomeContent);



// WEBPACK FOOTER //
// ./src/components/pages/HomeContent.js